import { Gamepad2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CasinoTypeButtonProps {
	label: string
	icon: React.ComponentType<{ className?: string }> | string | null
	isActive: boolean
	onClick: () => void
}

export function CasinoTypeButton({ label, icon, isActive, onClick }: CasinoTypeButtonProps) {
	const Icon = typeof icon == 'function' || typeof icon === 'object' ? icon : null

	return (
		<button
			type='button'
			onClick={onClick}
			className={cn('group relative shrink-0 overflow-hidden rounded-xl border p-0.5 transition-colors', isActive ? 'border-primary' : 'border-border')}
		>
			<span
				className={cn(
					'relative flex items-center gap-2 overflow-hidden rounded-[10px] px-4 py-2.5',
					isActive
						? 'bg-card bg-[radial-gradient(circle_3rem_at_50%_125%_in_hsl_shorter_hue,transparent_0%,hsl(var(--secondary))_100%),linear-gradient(90deg,hsl(var(--primary)/0.5),hsl(var(--primary)/0.5))] shadow-[inset_0_-12px_24px_hsl(var(--primary)/0.08)]'
						: 'bg-secondary',
				)}
			>
				{Icon ? (
					<Icon className={cn('h-6 w-6', isActive ? 'text-primary' : 'text-icon-muted transition-colors duration-200 ease-in-out group-hover:text-primary')} />
				) : icon ? (
					<span
						aria-hidden
						className={cn(
							'h-6 w-6 bg-current [-webkit-mask-position:center] [-webkit-mask-repeat:no-repeat] [-webkit-mask-size:contain] [mask-position:center] [mask-repeat:no-repeat] [mask-size:contain]',
							isActive ? 'text-primary' : 'text-icon-muted transition-colors duration-200 ease-in-out group-hover:text-primary',
						)}
						style={{
							maskImage: `url(${icon})`,
							WebkitMaskImage: `url(${icon})`,
						}}
					/>
				) : (
					<Gamepad2 className={cn('h-6 w-6', isActive ? 'text-primary' : 'text-icon-muted transition-colors duration-200 ease-in-out group-hover:text-primary')} />
				)}
				<span className={cn('text-sm font-medium tracking-[-0.21px]', isActive ? 'text-foreground' : 'text-muted-foreground')}>{label}</span>
				<span
					className={cn(
						'absolute bottom-0.5 left-1/2 h-0.5 w-6 -translate-x-1/2 rounded-full transition-[width,background-color,box-shadow] duration-200 ease-in-out group-hover:w-8',
						isActive
							? 'bg-primary shadow-[0_0_12px_4px_hsl(var(--primary)/0.55)]'
							: 'bg-border group-hover:bg-primary group-hover:shadow-[0_0_6px_2px_hsl(var(--primary)/0.55)]',
					)}
					aria-hidden
				/>
			</span>
		</button>
	)
}
